
/**
 * http Ajax 请求插件封装
 */
var Http = {};
Http.install = function (Vue, options) {

    //登录信息
    Vue.prototype.$getAccessToken = () => {
        var accessToken = window.sessionStorage.getItem('accessToken');
        if (accessToken == null) {
            accessToken = '';
        }
        return accessToken;
    },
    Vue.prototype.$setAccessToken = (accessToken) => {
        return window.sessionStorage.setItem('accessToken', accessToken);
    },
    Vue.prototype.$getUserInfo = () => {
        return JSON.parse(window.sessionStorage.getItem('userInfo'));
    },
    Vue.prototype.$setUserInfo = (userInfo) => {
        return window.sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    Vue.prototype.$clearCache = () => {
        window.sessionStorage.removeItem('userInfo');
        window.sessionStorage.removeItem('accessToken');
    }
        Vue.prototype.$errorNotice = function ($message = '系统错误') {
            this.$message.error($message);
        },
        // 3. 注入组件
        Vue.mixin({
            created: function () {
                //配置axios
                //基础请求host
                // options.axios.defaults.baseURL = options.config.API_HOST;
                //headser 头

                options.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
                options.axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';
                // options.axios.defaults.headers.get['Content-Type'] = 'text/123';
                //请求超时间
                options.axios.defaults.timeout = 30000;
                // console.log(options.axios.interceptors.response)
                // options.axios.interceptors.response.setHeader("Content-Type", "application/json; charset=UTF-1111");
                //POST传参序列化(添加请求拦截器)
                options.axios.interceptors.request.use((config) => {
                    //在发送请求之前做某件事
                    return config;
                }, (error) => {
                    console.log("错误的传参", 'fail');
                    return Promise.reject(error);
                });
                //返回状态判断(添加响应拦截器)
                options.axios.interceptors.response.use((res) => {
                    return res;
                }, (error) => {
                    console.log("网络异常", 'fail');
                    return Promise.reject(error);
                });

            },
            methods: {

                // 获取是否拥有接口权限
                $hasAuth: function (apiPath) {
                    if (Object.prototype.toString.call(apiPath) === "[object String]") {
                        let authList = this.$userInfo().not_auth;
                        let length = authList.filter(function (item) {
                            //不区分大小写
                            return item.path === apiPath;
                        }).length;
                        return length == 0;
                    } else {
                        console.error("$hasAuth() argument is String, got Other!");
                        return false;
                    }
                },
                $Request: function (method, url, data = {}, headers = {}, loading = true) {
                    let pageLoading;
                    if (loading) {
                        pageLoading = this.$loading({
                            lock: true,
                            text: '努力加载中...',
                            // spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                    }
                    //拼接heder
                    var header = this.$setHeader();
                    for (var i in headers) {
                        header[i] = headers[i];
                    }
                    let config = this.$Config(method, url, data, header);
                    return new Promise((resolve, reject) => {
                        options.axios.request(config).then(response => {
                            switch (response.status) {
                                case 200:
                                    resolve(response.data);
                                    break;
                                case 400:
                                    this.$errorNotice(response.data.message);
                                    reject(response.data.message);
                                    break;
                                case 401:
                                    this.$clearCache();
                                    this.$errorNotice('登录失效，请重新登录');
                                    reject(response.data.message);
                                    this.$router.push({ path: '/login' })
                                    break;
                                case 402:
                                    this.$clearCache();
                                    this.$errorNotice('登录失效，请重新登录');
                                    reject(response.data.message);
                                    this.$router.push({ path: '/login' });
                                    break;
                                case 403:
                                    this.$errorNotice('没有权限查看');
                                    reject(response.data.message);
                                    //this.$router.push({ path: '/error/403' })
                                    this.$router.go(-1);
                                    break;
                                case 404:
                                    this.$errorNotice(response.data.message);
                                    reject(response.statusText);
                                    break;
                                default:
                                    this.$errorNotice('未知错误----');
                                    reject(response.statusText);
                                    break;
                            }
                            setTimeout(function () {
                                if (loading) {
                                    pageLoading.close();
                                }
                            }, 500)
                        }, err => {
                            // 请求 >=500 时候的报错信息
                            if (loading) {
                                pageLoading.close();
                            }
                            this.$errorNotice();
                            reject(err);
                        }).catch((error) => {
                            if (loading) {
                                pageLoading.close();
                            }
                            // 捕捉代码执行时候的错误，抛出到promise错误当中 (resolve对应then方法，then方法中的代码错误，是直接抛出的，不经过这里，直接在promise的catch)
                            reject(error)
                        })
                    });
                },
                /**
                 * Ajax GET 请求方式
                 * @param {string} url 请求路径
                 * @param {object} params 请求参数，为空传空对象
                 * @param {boolean} loading 是否添加加载loading
                 * @return Promise 对象
                 */
                $Get: function (url, params = {}, loading) {
                    return this.$Request('get', url, params, {}, loading);
                },
                /**
                 * Ajax POST 请求方式
                 * @param {string} url 请求路径
                 * @param {object} data 请求参数，为空传空对象
                 * @param {boolean} loading 是否添加加载loading
                 * @return Promise 对象
                 */
                $Post: function (url, data = {}, loading) {
                    return this.$Request('post', url, data, {}, loading);
                },
                /**
                 * Ajax PUT 请求方式
                 * @param {string} url 请求路径
                 * @param {object} data 请求参数，为空传空对象
                 * @param {boolean} loading 是否添加加载loading
                 * @return Promise 对象
                 */
                $Put: function (url, data = {}, loading) {
                    return this.$Request('put', url, data, {}, loading);
                },
                /**
                 * Ajax DELETE 请求方式
                 * @param {string} url 请求路径
                 * @param {object} data 请求参数，为空传空对象
                 * @param {boolean} loading 是否添加加载loading
                 * @return Promise 对象
                 */
                $Delete: function (url, params = {}, loading) {
                    return this.$Request('delete', url, params, {}, loading);
                },
                /**
                 * Ajax 表单下载文件
                 * @param {string} url 请求路径
                 * @param {object} data 请求选项，key为input的name，type为input类型，value是input的value
                 */
                $download: function (url, data = {}) {
                    let form = document.createElement('form');
                    form.display = "none";
                    form.method = "post";
                    form.action = options.config.API_HOST + url;
                    data['access_token'] = this.$accessToken();
                    for (var key in data) {
                        let input = document.createElement('input');
                        input.name = key;
                        input.type = "hidden";
                        input.value = data[key] || "";
                        form.appendChild(input);
                    }
                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                },
                //axios 配置项
                $Config: function (method, url, data, headers) {
                    if (method === 'put' || method === 'post') {
                        var params = {};
                    } else {
                        var params = data;
                        var data = {};

                    }
                    return {
                        //`url`是请求的服务器地址
                        url: url,
                        //`method`是请求资源的方式
                        method: method, //default
                        //如果`url`不是绝对地址，那么`baseURL`将会加到`url`的前面
                        //当`url`是相对地址的时候，设置`baseURL`会非常的方便
                        baseURL: options.config.API_HOST,
                        //`transformRequest`选项允许我们在请求发送到服务器之前对请求的数据做出一些改动
                        //该选项只适用于以下请求方式：`put/post/patch`
                        //数组里面的最后一个函数必须返回一个字符串、-一个`ArrayBuffer`或者`Stream`
                        transformRequest: [function (data) {
                            //在这里根据自己的需求改变数据
                            return options.qs.stringify(data);
                        }],
                        //`transformResponse`选项允许我们在数据传送到`then/catch`方法之前对数据进行改动
                        transformResponse: [function (data) {
                            //在这里根据自己的需求改变数据
                            // console.log(data)
                            return data;
                        }],
                        //`headers`选项是需要被发送的自定义请求头信息
                        headers: headers,
                        //`params`选项是要随请求一起发送的请求参数----一般链接在URL后面
                        //他的类型必须是一个纯对象或者是URLSearchParams对象
                        params: params,
                        //`paramsSerializer`是一个可选的函数，起作用是让参数（params）序列化
                        //例如(https://www.npmjs.com/package/qs,http://api.jquery.com/jquery.param)
                        paramsSerializer: function (params) {
                            return options.qs.stringify(params);
                        },
                        //`data`选项是作为一个请求体而需要被发送的数据
                        //该选项只适用于方法：`put/post/patch`
                        //当没有设置`transformRequest`选项时dada必须是以下几种类型之一
                        //string/plain/object/ArrayBuffer/ArrayBufferView/URLSearchParams
                        //仅仅浏览器：FormData/File/Bold
                        //仅node:Stream
                        data: data,
                        //`timeout`选项定义了请求发出的延迟毫秒数
                        //如果请求花费的时间超过延迟的时间，那么请求会被终止
                        timeout: 30000,
                        //`withCredentails`选项表明了是否是跨域请求
                        withCredentials: false,//default
                        //`adapter`适配器选项允许自定义处理请求，这会使得测试变得方便
                        //返回一个promise,并提供验证返回
                        // adapter: function(config){
                        //     return Promise.reject(config);
                        // },
                        //`auth`表明HTTP基础的认证应该被使用，并提供证书
                        //这会设置一个authorization头（header）,并覆盖你在header设置的Authorization头信息
                        // auth: {
                        //     username:"zhangsan",
                        //     password: "s00sdkf"
                        // },
                        //返回数据的格式
                        //其可选项是arraybuffer,blob,document,json,text,stream
                        responseType: 'json',//default
                        // `xsrfCookieName` 是用作 xsrf token 的值的cookie的名称
                        xsrfCookieName: 'XSRF-TOKEN',//default
                        // `xsrfHeaderName` 是承载 xsrf token 的值的 HTTP 头的名称
                        xsrfHeaderName: 'X-XSRF-TOKEN',//default
                        //`onUploadProgress`上传进度事件
                        onUploadProgress: function (progressEvent) {
                            //上传处理进度事件
                            //console.log(progressEvent);
                        },
                        onDownloadProgress: function (progressEvent) {
                            //下载处理进度事件
                        },
                        //相应内容的最大值
                        maxContentLength: 2000,
                        //`validateStatus`定义了是否根据http相应状态码，来resolve或者reject promise
                        //如果`validateStatus`返回true(或者设置为`null`或者`undefined`),那么promise的状态将会是resolved,否则其状态就是rejected
                        validateStatus: function (status) {
                            return status >= 200 && status < 500;//default
                        },
                        //`maxRedirects`定义了在nodejs中重定向的最大数量
                        maxRedirects: 2,//default
                        //`httpAgent/httpsAgent`定义了当发送http/https请求要用到的自定义代理
                        //keeyAlive在选项中没有被默认激活
                        // httpAgent: new http.Agent({keeyAlive:true}),
                        // httpsAgent: new https.Agent({keeyAlive:true}),
                        //proxy定义了主机名字和端口号，
                        //`auth`表明http基本认证应该与proxy代理链接，并提供证书
                        //这将会设置一个`Proxy-Authorization` header,并且会覆盖掉已经存在的`Proxy-Authorization`  header
                        // proxy: {
                        //     host:'127.0.0.1',
                        //     port: 9000,
                        //     auth: {
                        //         username:'skda',
                        //         password:'radsd'
                        //     }
                        // },
                        //`cancelToken`定义了一个用于取消请求的cancel token
                        //详见cancelation部分
                        // cancelToken: new cancelToken(function(cancel){

                        // })
                    }
                },
                //异常处理方法
                $Exception: function (response, callback) {
                    if (response.data.code == 200) { //请求成功
                        return callback(response.data.data);
                    } else if (response.data.code == 400) { //参数错误
                        this.$alert(response.data.message);
                        return false;
                    } else if (response.data.code == 401) { //需要登录
                        window.sessionStorage.removeItem('userInfo');
                        window.sessionStorage.removeItem('accessToken');
                        this.$alert(response.data.message);
                        this.$router.push({ path: '/login' })
                        return false;
                    }
                },
                $setHeader: function () {
                    var accessToken = this.$getAccessToken();
                    //加密算法
                    var validate = new Array();
                    validate.push(accessToken);
                    validate.push(options.config.APP_TYPE);
                    validate.push(options.config.DEVICE_CODE);
                    validate.push(options.config.SECRET);
                    validate.push(options.config.VERSION);
                    var auth = validate.join('_');
                    auth = options.md5(auth);
                    auth = auth.substring(5, 30);
                    var sign = options.md5(options.config.SALT + '_' + auth);
                    //发送header头
                    var headers = {
                        'App-Type': options.config.APP_TYPE,
                        'Device-Code': options.config.DEVICE_CODE,
                        'Sign': sign,
                        'Version': options.config.VERSION,
                        'Authorization': 'Bearer ' + accessToken,
                        // 'Content-Type': 'application/json; charset=UTF-8'

                    }
                    return headers;
                },
            }
        })

}
export default Http;
//module.exports = Http;



// WEBPACK FOOTER //
// ./src/utils/http.js